"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnCode = void 0;
// From https://github.com/OffchainLabs/arb-os/blob/develop/arb_os/constants.json
var ReturnCode;
(function (ReturnCode) {
    ReturnCode[ReturnCode["TransactionSuccess"] = 0] = "TransactionSuccess";
    ReturnCode[ReturnCode["EVMRevert"] = 1] = "EVMRevert";
    /**
     *Arbitrum is too congested to process the transaction
     */
    ReturnCode[ReturnCode["TooCongested"] = 2] = "TooCongested";
    /**
     * Not enough balance to pay for maxGas at gasPrice (for retryables: not enough to cover base submission cost)
     */
    ReturnCode[ReturnCode["InsufficientBalanceForMaxGas"] = 3] = "InsufficientBalanceForMaxGas";
    /**
     * Not enough balance for execution (for retryables: not enough to cover callvalue + base submission cost)
     */
    ReturnCode[ReturnCode["InsufficientBalanceForExecution"] = 4] = "InsufficientBalanceForExecution";
    /**
     * Wrong nonce used in transaction
     */
    ReturnCode[ReturnCode["WrongNonce"] = 5] = "WrongNonce";
    /**
     * Transaction was not formatted correctly
     */
    ReturnCode[ReturnCode["InvalidFormat"] = 6] = "InvalidFormat";
    /**
     * Cannot deploy to specified address ( ** defensive code that should never be triggered ** )
     */
    ReturnCode[ReturnCode["CannotDeploy"] = 7] = "CannotDeploy";
    /**
     * Exceeded transaction gas limit
     */
    ReturnCode[ReturnCode["GasLimitExceeded"] = 8] = "GasLimitExceeded";
    /**
     * Amount of ArbGas provided for the tx is less than the amount required to cover L1 costs (the base tx charge plus L1 calldata charge)
     */
    ReturnCode[ReturnCode["InsufficientArbGasForL1Costs"] = 9] = "InsufficientArbGasForL1Costs";
    /**
     * Transaction is below the minimum required arbgas
     */
    ReturnCode[ReturnCode["InsufficientArbGas"] = 10] = "InsufficientArbGas";
    /**
     * Transaction set an arbgas price that was too low
     */
    ReturnCode[ReturnCode["InsufficientArbGasPrice"] = 11] = "InsufficientArbGasPrice";
    /**
     * Insufficient gas for retryable auto-redeem
     */
    ReturnCode[ReturnCode["InsufficientBalanceForAutoRedeem"] = 12] = "InsufficientBalanceForAutoRedeem";
    /**
     * Sender not permitted
     */
    ReturnCode[ReturnCode["SenderNotPermitted"] = 13] = "SenderNotPermitted";
    /**
     * Sequence number too low
     */
    ReturnCode[ReturnCode["SequenceNumberTooLow"] = 14] = "SequenceNumberTooLow";
    /**
     * Sequence number too high
     */
    ReturnCode[ReturnCode["SequenceNumberTooHigh"] = 15] = "SequenceNumberTooHigh";
    /**
     * Execution ran out of gas
     */
    ReturnCode[ReturnCode["ExecutionRanOutOfGas"] = 16] = "ExecutionRanOutOfGas";
    ReturnCode[ReturnCode["Unknown"] = 255] = "Unknown";
})(ReturnCode = exports.ReturnCode || (exports.ReturnCode = {}));
